import React from "react";
import Seo from "../components/Seo";

const SECTIONS = [
  {
    title: "1. Agreement",
    body: (
      <>
        By placing an order or using elegantaffairs.shop, you agree to these Terms of Service.
        Please read them carefully. If you do not agree, please do not use the site.
      </>
    ),
  },
  {
    title: "2. About our store",
    body: (
      <>
        Elegant Affairs is a curated online retailer of designer luxury handbags. We are an
        independent retailer and are <strong>not affiliated with, endorsed by, or an authorised
        reseller of</strong> any of the designer brands featured. All trademarks remain the property of
        their respective owners.
      </>
    ),
  },
  {
    title: "3. 100% Authentic — Money-back guarantee",
    body: (
      <>
        Every bag we ship is verified before dispatch. If a bag we sold you is ever
        determined to be inauthentic by an independent authentication service, we will refund
        100% of the purchase price including original shipping. Refunds are issued within 5
        business days of confirmed inauthenticity.
      </>
    ),
  },
  {
    title: "4. Pricing & payment",
    body: (
      <>
        All prices are in <strong>USD</strong>. We accept payment through Stripe, which supports major
        credit/debit cards, Apple Pay and Google Pay. Payment is processed at checkout. We
        reserve the right to cancel an order in case of pricing errors, fraud, or
        unavailability and will refund any amount charged in full.
      </>
    ),
  },
  {
    title: "5. Shipping",
    body: (
      <>
        Orders are shipped tracked, worldwide. Free shipping is included on orders over $200.
        Delivery times vary by destination — typically 3–10 business days. We are not
        responsible for customs duties, taxes, or fees levied by the destination country;
        these are the buyer's responsibility.
      </>
    ),
  },
  {
    title: "6. Returns",
    body: (
      <>
        You may return your bag within <strong>14 days</strong> of receipt for a full refund (excluding
        original shipping fees), provided the item is in its original, unused condition with all tags,
        dust bag and packaging intact. To start a return, email{" "}
        <a href="mailto:concierge@elegantaffairs.shop?subject=Return%20Request" className="underline">
          concierge@elegantaffairs.shop
        </a>. Return shipping is the buyer's responsibility unless the item arrived damaged or
        incorrect.
      </>
    ),
  },
  {
    title: "7. Liability",
    body: (
      <>
        To the maximum extent permitted by law, our liability for any claim arising from
        your purchase is limited to the amount you paid for the item. We are not liable for
        indirect, incidental, or consequential damages.
      </>
    ),
  },
  {
    title: "8. Intellectual property",
    body: (
      <>
        The Elegant Affairs name, logo, photography, and copy are our property. You may not
        copy, reproduce, or use our content for commercial purposes without permission.
        Designer brand names appearing on this site are property of their respective trademark
        owners and used solely to identify products lawfully resold under the first-sale doctrine.
      </>
    ),
  },
  {
    title: "9. User conduct",
    body: (
      <>
        You agree not to attempt to disrupt the site, attempt unauthorised access, submit
        fraudulent orders, or use the site for any unlawful purpose.
      </>
    ),
  },
  {
    title: "10. Governing law",
    body: (
      <>
        These terms are governed by the laws of the United States, without regard to conflict
        of law principles. Any disputes will be handled in the courts of competent jurisdiction.
      </>
    ),
  },
  {
    title: "11. Changes",
    body: (
      <>
        We may update these terms from time to time. The &ldquo;Last updated&rdquo; date below reflects
        the latest version. Continued use of the site after changes constitutes acceptance.
      </>
    ),
  },
  {
    title: "12. Contact",
    body: (
      <>
        Questions? Email{" "}
        <a href="mailto:concierge@elegantaffairs.shop" className="underline">
          concierge@elegantaffairs.shop
        </a>{" "}
        — we reply within 24 hours.
        <div className="mt-4 p-4 border-l-2 border-[var(--mn-accent)] bg-neutral-50/60">
          <p className="text-xs uppercase tracking-[0.22em] text-[var(--mn-muted)] mb-2">Postal address</p>
          <p className="text-sm text-[var(--mn-ink)] not-italic">
            Elegant Affairs<br />
            10405 North Centerway Drive, Ste C #170<br />
            Peoria, IL 61615<br />
            United States
          </p>
          <p className="text-xs text-[var(--mn-muted)] mt-3">
            Returns &amp; correspondence — please include your order number (EA-XXXXXXXX).
          </p>
        </div>
      </>
    ),
  },
];

export default function Terms() {
  return (
    <div className="pt-32 pb-24" data-testid="terms-page">
      <Seo
        title="Terms of Service"
        description="The terms governing purchases at Elegant Affairs — 14-day returns, money-back authenticity guarantee, USD pricing."
      />
      <div className="max-w-[860px] mx-auto px-6 md:px-12">
        <p className="eyebrow">Legal</p>
        <h1 className="font-display text-5xl md:text-7xl mt-4 leading-[0.95] tracking-tighter">
          Terms of Service.
        </h1>
        <p className="text-[var(--mn-ink-2)] mt-6 leading-relaxed">
          The fine print for shopping with us — written to be readable.
        </p>
        <p className="text-xs uppercase tracking-[0.22em] text-[var(--mn-muted)] mt-4">
          Last updated: April 2026
        </p>

        <div className="mt-16 space-y-12">
          {SECTIONS.map((s) => (
            <section key={s.title}>
              <h2 className="font-display text-2xl md:text-3xl tracking-tight">{s.title}</h2>
              <div className="text-[var(--mn-ink-2)] leading-relaxed mt-4 text-base">{s.body}</div>
            </section>
          ))}
        </div>

        <p className="mt-20 text-xs text-[var(--mn-muted)] leading-relaxed">
          These terms are a reasonable starting point. For binding compliance with your specific
          jurisdiction, please consult a qualified legal advisor.
        </p>
      </div>
    </div>
  );
}
